import useScrollToTopButton1Logic from "./button-scroll-to-top-skin-1.hook";
import useOnClickToTopLogic from "../../button-scroll-to-top.hook";
import styles from "./button-scroll-to-top-skin-1.module.css";

const ScrollToTopSkin1 = () => {
  const { scrollBahevior } = useScrollToTopButton1Logic();
  const { handlerBackToTop, alignButtonStyles } = useOnClickToTopLogic();

  return (
    <>
      {scrollBahevior &&
      <div
        className={styles.buttonScrollToTopSkin1Container}
        role='scroll-to-top-skin1'
        style={alignButtonStyles}>

          <button className={styles.btnBox} onClick={handlerBackToTop}>
            <div className={styles.scrollBtnIconBox}>
              <span className='icon-arrow-go-up'></span>
            </div>
          </button>
        </div>}

    </>);

};

export default ScrollToTopSkin1;